<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        label="部门名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'department_name',
            { rules: [{ required: true, message: '请填写部门名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this)
    };
  },
  mounted() {},
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, pramas) => {
        //   console.log(pramas)
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.customer +
            "Company/addDepartment";
          axios
            .post(url, {
              department_name: pramas.department_name,
              token: window.localStorage.getItem("xnwfPcToken")
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.form.resetFields();
                this.$emit("hideInAdd", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
